import { useEffect, useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import {
  fetchScanPerformanceByTimePerStore,
  PerformanceScanByTimePerStore,
} from '../fetch/fetchScanPerformanceByTimePerStore';

export function useGetPerformanceScanListByTimePerStore(
  startDate: Dayjs,
  endDate: Dayjs
): {
  performanceScanList: PerformanceScanByTimePerStore[];
  isLoading: boolean;
} {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [performanceScanList, setPerformanceScanList] =
    useState<PerformanceScanByTimePerStore[]>(null);

  const startString = dayjs(startDate).format('YYYY-MM-DD');
  const endString = dayjs(endDate).format('YYYY-MM-DD');

  console.log('startString', startString);
  console.log('endString', endString);

  useEffect(() => {
    const fetchPerformanceScanListMethod = async () => {
      const performanceScanListResult =
        await fetchScanPerformanceByTimePerStore(startString, endString);

      setPerformanceScanList(performanceScanListResult);
      setIsLoading(false);
    };

    fetchPerformanceScanListMethod();
  }, [endString, setIsLoading, startString]);

  return { performanceScanList, isLoading };
}
